import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { Typography, Card, Box, Divider} from '@mui/material';
import { selectProgramsByOrgId, createProgramLocation, deleteProgramLocation} from 'app/store/programsSlice';
import { selectLocationById, selectLocationProgramsById } from 'app/store/orgLocationsSlice';
import { selectChannel } from 'app/store/channelsSlice';
import dispatchSubmit from 'app/shared-components/util/dispatchSubmit';
import TitledPanel from 'app/shared-components/layout/TitledPanel';
import ProgramList from 'app/shared-components/organization/ProgramList';
import CardActionsBaseMenu from 'app/shared-components/util/CardActionsBaseMenu';



function LocationPrograms(props) {
  const routeParams = useParams();
  const navigate= useNavigate();
  const {groupId, locationId} = routeParams;
  const orgChannel= useSelector(selectChannel(groupId));
  const permissions = orgChannel?.callerPermissions;
  const location = useSelector(selectLocationById(locationId));
  const selectedPrograms= useSelector(selectLocationProgramsById(locationId));
  const orgPrograms= useSelector(selectProgramsByOrgId(groupId));
  const filteredPrograms= orgPrograms.filter((program) => !selectedPrograms.find(prog => prog.id === program.id));
  const dispatch = useDispatch();
  const title= location?.name + " Programs";
  const returnPath= "/apps/organization/" + groupId + "/locations";
  
  
  function addProgram(programId) {
	dispatchSubmit({dispatch: dispatch, 
	                submitFunction: createProgramLocation({programId: programId, locationId: locationId}), 
	                successMessage:  "Program Added"});
  }
  
  function removeProgram(programId) {
	dispatchSubmit({dispatch: dispatch, 
	                submitFunction: deleteProgramLocation({programId: programId, locationId: locationId}), 
	                successMessage:  "Program Removed"});
  }
  
  function handleGotoProgram(programId) {
	  navigate('/program/' + programId);
  }

  return (
	<TitledPanel title={title} returnPath={returnPath}>
	   <Box
        className="w-full border-2 flex flex-col items-center p-10 pb-20 mb-36"
        sx={{backgroundColor: (theme) => theme.palette.background.default,
             borderRadius: '5px'}}
        >
	         
		<Typography className="font-semibold mb-4 text-24">Selected Programs</Typography>
		<Divider className="w-full mb-10"  sx={{ borderBottomWidth: 2 }}/>

		<ProgramList cols="single" emptyMessage="No programs for this location" noLink
		              programs={selectedPrograms} menu={RemoveProgramMenu}/>
	   </Box>  
	   
	   <Box
        className="w-full border-2 flex flex-col items-center p-10 pb-20 mb-36"
        sx={{backgroundColor: (theme) => theme.palette.background.default,
             borderRadius: '5px'}}
        >
	                   
		<Typography className="font-semibold mb-4 text-24">Other Programs</Typography>
        <Divider className="w-full mb-10"  sx={{ borderBottomWidth: 2 }} />

		<ProgramList cols="single" emptyMessage="No programs for this organization" noLink
		              programs={filteredPrograms} menu={AddProgramMenu}/>
     	</Box> 			 
    </TitledPanel>
      
  );
  
  function AddProgramMenu(props) {
	  const { program } = props;
	  const allItems= [];
	  
	  allItems.push({onClick: () => handleGotoProgram(program.id), 
	                 key: "gotoProgram", 
	                 icon: "heroicons-outline:arrow-right", 
	                 text: "View Program"});
	  
	  if (permissions.owner || permissions?.admin) 
	              allItems.push({onClick: () => addProgram(program.id), 
	                             key: "addProgram", 
	                             icon: "heroicons-outline:plus-circle", 
	                             text: "Add Program"});
	  
	  return (
		<CardActionsBaseMenu items={allItems} />
	  );
   }
	
   function RemoveProgramMenu(props) {
	  const { program } = props;
	  const allItems= [];
	  
	  allItems.push({onClick: () => handleGotoProgram(program.id),
	                 key: "gotoProgram", 
	                 icon: "heroicons-outline:arrow-right", 
	                 text: "View Program"});
	  
	  if (permissions.owner || permissions?.admin) 
	              allItems.push({onClick: () => removeProgram(program.id), 
	                             key: "removeProgram", 
	                             icon: "heroicons-outline:minus-circle", 
	                             text: "Remove Program"});
	  
	  return (
		<CardActionsBaseMenu items={allItems} />
	  );
   }
}

export default LocationPrograms;
